<template>
  <div :style="elemStyle" class="tooltip-container"></div>
</template>

<script>
/**
 * Crea un tooltip a destra delle voci di menu
 * @module components/common/TooltipContainer
 */
  export default {
    name: 'tooltip-container',
    data () {
      return {
        elemStyle: {
          opacity: 0,
          top: 0,
          left: '85px'
        }
      }
    },
    methods: {
      handleChange (ev, node, dir) {
        if(dir == 'out'){
          this.$el.style.display = 'none'
          this.$el.style.opacity = 0
          return
        }

        let text = node.querySelector('.list__tile__title').innerHTML
        
        this.$el.innerHTML = text

        this.$el.style.top = `${node.getBoundingClientRect().top + 5}px`
        this.$el.style.display = 'flex'
        setTimeout(() => {
          this.$el.style.opacity = 1
        })
      },
      is_touch_device () {
        return 'ontouchstart' in window
            || navigator.maxTouchPoints;
      }
    },
    mounted () {
      document.querySelectorAll('.miniMenu.navigation-drawer .list li').forEach(node => {
        if(this.is_touch_device()){
          node.addEventListener('touchstart', (ev) => this.handleChange(ev, node, 'in'), false);
          node.addEventListener('touchend', (ev) => this.handleChange(ev, node, 'out'), false);
        }else{
          node.addEventListener('mouseenter', (ev) => this.handleChange(ev, node, 'in'), false);
          node.addEventListener('mouseleave', (ev) => this.handleChange(ev, node, 'out'), false);
        }
      })
      
    }
  }
</script>

<style lang="stylus">
.tooltip-container
  position: absolute
  width: auto
  min-width: 85px
  height: 38px
  z-index: 99
  display: flex
  align-items: center
  justify-content: center
  opacity: 1
</style>


// WEBPACK FOOTER //
// src/components/common/TooltipContainer.vue